import { ViewChild } from '@angular/core';
import { Component, Input, OnInit, NgZone } from '@angular/core';

@Component({
  selector: 'sm-crousel',
  templateUrl: './crousel.component.html',
  styleUrls: ['./crousel.component.scss'],
})
export class CrouselComponent implements OnInit {
  public currentIndex: number = 0;
  @ViewChild('video') video: any;

  @Input() slides: any[] = [
    {
      image:
        'https://images.unsplash.com/photo-1619630110059-13c4617ca2be?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      type: 'image',
    },
    { image: 'https://picsum.photos/seed/picsum/1200/300', type: 'image' },
    {
      image:
        'https://images.unsplash.com/photo-1619630110059-13c4617ca2be?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      type: 'image',
    },
    {
      image: 'https://picsum.photos/seed/picsum/1200/300',
      type: 'image',
    },
    {
      image:
        'https://storage.googleapis.com/salon-market_entity_videos/time_stamp_1620030418602_2021-04-15 19-15-01.mp4',
      type: 'video',
    },
  ];
  constructor(private _ngZone: NgZone) {}

  next() {
    console.log(this.slides, this.currentIndex);
    if (this.currentIndex !== this.slides.length - 1) {
      this._ngZone.run(() => {
        console.log('hii');
        this.currentIndex++;
        console.log(this.slides[this.currentIndex].image);
        this.video?.nativeElement?.load();
      });
    }
  }
  prev() {
    if (this.currentIndex !== 0) {
      this._ngZone.run(() => {
        console.log('hii');
        this.currentIndex--;
        console.log(this.slides[this.currentIndex].image);
        this.video?.nativeElement?.load();
      });
    }
  }

  ngOnInit(): void {}
}
